import {DataTable} from '@/components/atoms'

const ProductsTable = props => {
  const columns = [
    {columnKey: 'name', header: 'Name'},
    {columnKey: 'product_id', header: 'Product Id'},
    {columnKey: 'status', header: 'Status'},
    {columnKey: 'size', header: 'Size'},
    {columnKey: 'category', header: 'Category'},
    {columnKey: 'brand', header: 'Brand'},
    {columnKey: 'include_exclude', header: 'Include/Exclude'},
  ]

  const tableData = [
    {
      name: 'Sales Target NAme',
      product_id: '100',
      status: '88',
      size: '250',
      category: 'Category',
      brand: 'Brand',
      include_exclude: 'Include',
    },
    {
      name: 'Sales Target NAme',
      product_id: '100',
      status: '88',
      size: '250',
      category: 'Category',
      brand: 'Brand',
      include_exclude: 'Include',
    },
    {
      name: 'Sales Target NAme',
      product_id: '100',
      status: '88',
      size: '250',
      category: 'Category',
      brand: 'Brand',
      include_exclude: 'Include',
    },
    {
      name: 'Sales Target NAme',
      product_id: '100',
      status: '88',
      size: '250',
      category: 'Category',
      brand: 'Brand',
      include_exclude: 'Include',
    },
    {
      name: 'Sales Target NAme',
      product_id: '100',
      status: '88',
      size: '250',
      category: 'Category',
      brand: 'Brand',
      include_exclude: 'Include',
    },
    {
      name: 'Sales Target NAme',
      product_id: '100',
      status: '88',
      size: '250',
      category: 'Category',
      brand: 'Brand',
      include_exclude: 'Include',
    },
    {
      name: 'Sales Target NAme',
      product_id: '100',
      status: '88',
      size: '250',
      category: 'Category',
      brand: 'Brand',
      include_exclude: 'Include',
    },
  ]

  const filters = [
    // max 3 filters
    {
      disabled: false,
      label: 'Filter',
      listLabel: 'Header',
      onChange: () => true,
      options: [
        {id: '1', label: 'Option 1'},
        {id: '2', label: 'Option 2'},
        {id: '3', label: 'Option 3'},
      ],
    },
    {
      disabled: false,
      label: 'Filter',
      listLabel: 'Header',
      onChange: () => true,
      options: [
        {id: '1', label: 'Option 1'},
        {id: '2', label: 'Option 2'},
        {id: '3', label: 'Option 3'},
      ],
    },
    {
      disabled: false,
      label: 'Filter',
      listLabel: 'Header',
      onChange: () => true,
      options: [
        {id: '1', label: 'Option 1'},
        {id: '2', label: 'Option 2'},
        {id: '3', label: 'Option 3'},
      ],
    },
  ]

  return (
    <div className="products-table">
      <DataTable
        columns={columns}
        data={tableData}
        filters={filters}
        isDark
        isExpandable={false}
        pageIndex={0}
        pageSize={10}
        selection={props.isUploadTable ? 'single' : 'multiple'}
        onUpdate={() => {}}
        size="large"
        tableDescription=""
        tableHeader={props.isUploadTable ? '' : 'Select Products to Include or Exclude'}
        toolbarActions={
          props.isUploadTable
            ? []
            : [
                {
                  text: 'Include',
                  variant: 'secondary',
                  disabled: true,
                  onClick: () => alert('secondary button clicked'),
                },
                {
                  text: 'Exclude',
                  variant: 'secondary',
                  disabled: true,
                  onClick: () => alert('primary button clicked'),
                },
              ]
        }
      />
    </div>
  )
}

export default ProductsTable
